export default "__VITE_ASSET__039BC434__"